import { ReactComponent as NuvamaLogo } from "../../assets/images/svg/nuvama_logo.svg";
import activatedHomeIcon from "../../assets/images/svg/homeIcon.svg";
import selectedSupportIcon from "../../assets/images/svg/selectedSupportIcon.svg";
import { useEffect, useLayoutEffect, useState } from "react";
import { useLocation } from "react-router";
import {
  getDecodedToken,
  // getDisplayDate,
  getUsersOffshoreValue,
  logout,
} from "../../utils/functions";
import {
  COMBINED,
  DOMESTIC,
  OFFSHORE,
  portfolioMenuDetails,
  homePageRoute,
  logoAriaLabel,
  familyOfficeTeamNameText,
  reportsMenuDetails,
} from "../../utils/constants";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import nuvamaexcel from "../../assets/images/png/nuvamaexcel.png";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import SettingsStore from "../../store/SettingsStore";
import PerformanceStore from "../../store/PerformanceStore";
import { useRef } from "react";
import SkipToMainContent from "../SkipToMainContent/SkipToMainContent";
import { forwardRef } from "react";
import ReportsMenuList from "./ReportsMenuList";
import ProfileMenuList from "./ProfileMenuList";
import SettingsMenuList from "./SettingsMenuList";
import PageNavigationLink from "../PageNavigationLink/PageNavigationLink";

const Header = observer(
  forwardRef(({ type, isLogoNavigationEnabled }) => {
    const ref = useRef(null);
    const settingRef = useRef(null);
    const profileRef = useRef(null);
    const itemRefs = useRef([]);
    const portfolioItemRefs = useRef([]);
    const settingsItemRefs = useRef([]);
    const profileItemRefs = useRef([]);
    const portfolioRef = useRef(null);

    const [domesticAndOffshoreValue, setDomesticAndOffshoreValue] =
      useState("");

    const [userDetails, setUserDetails] = useState({
      name: "",
      role: "",
    });
    const [profileArr, setProfileArr] = useState([]);
    const [activeTab, setActiveTab] = useState(type);
    const location = useLocation();
    const decodedToken = getDecodedToken();

    const profileMenuDetails = [
      {
        heading: "View Profile",
        image: null,
        role: "",
        sales: true,
        key: "profile",
        navigateTo: "/profile",
      },
      {
        heading: "Unlock Accounts",
        image: (
          <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.9987 8.79948H7.4987V6.29948C7.4987 4.92115 8.62036 3.79948 9.9987 3.79948C11.377 3.79948 12.4987 4.92115 12.4987 6.29948H14.1654C14.1654 4.00198 12.2962 2.13281 9.9987 2.13281C7.7012 2.13281 5.83203 4.00198 5.83203 6.29948V8.79948H4.9987C4.55667 8.79948 4.13275 8.97507 3.82019 9.28764C3.50763 9.6002 3.33203 10.0241 3.33203 10.4661V17.1328C3.33203 17.5748 3.50763 17.9988 3.82019 18.3113C4.13275 18.6239 4.55667 18.7995 4.9987 18.7995H14.9987C15.4407 18.7995 15.8646 18.6239 16.1772 18.3113C16.4898 17.9988 16.6654 17.5748 16.6654 17.1328V10.4661C16.6654 10.0241 16.4898 9.6002 16.1772 9.28764C15.8646 8.97507 15.4407 8.79948 14.9987 8.79948ZM8.38286 13.382C8.4853 12.9898 8.72698 12.6484 9.06276 12.4214C9.39855 12.1945 9.80548 12.0975 10.2075 12.1486C10.6096 12.1998 10.9793 12.3955 11.2476 12.6993C11.5158 13.0031 11.6644 13.3942 11.6654 13.7995C11.6649 14.0909 11.5876 14.3771 11.4413 14.6292C11.295 14.8813 11.0849 15.0903 10.832 15.2353V17.1328H9.16536V15.2353C8.85005 15.0546 8.60273 14.7755 8.46138 14.4407C8.32003 14.1059 8.29244 13.734 8.38286 13.382Z"
              fill="#03002F"
            />
          </svg>
        ),
        role: "managercustomer",
        sales: true,
        key: "unlockAccounts",
        navigateTo: "/unlockaccount",
      },
      {
        heading: "Switch Family",
        image: (
          <svg
            width="17"
            height="13"
            viewBox="0 0 17 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.70166 9.54071C0.315747 9.54071 0 9.85646 0 10.2424C0 10.6283 0.298205 10.944 0.684118 10.944C2.87681 10.944 4.98178 10.0845 6.52544 8.55839L5.59574 7.52344C4.31521 8.80397 2.54352 9.54071 0.70166 9.54071Z"
              fill="#03002F"
            />
            <path
              d="M7.91016 4.96173L8.83986 5.99668C10.1204 4.71615 11.8921 3.97941 13.7164 3.97941H14.2953L13.5761 4.69861C13.2954 4.97927 13.2954 5.41781 13.5761 5.68093C13.8392 5.9616 14.2953 5.9616 14.5584 5.68093L16.4529 3.76891C16.5757 3.64612 16.6634 3.45316 16.6634 3.27775C16.6634 3.08479 16.5932 2.90937 16.4529 2.78658L14.5408 0.87456C14.4005 0.734228 14.2251 0.664062 14.0497 0.664062C13.8743 0.664062 13.6988 0.734228 13.5585 0.87456C13.2779 1.15522 13.2779 1.59376 13.5585 1.85688L14.2777 2.57609H13.6988C11.5237 2.59363 9.43627 3.45316 7.91016 4.96173Z"
              fill="#03002F"
            />
            <path
              d="M16.4539 9.73697L14.5594 7.82495C14.4191 7.68462 14.2437 7.61445 14.0683 7.61445C13.8929 7.61445 13.7175 7.68462 13.5771 7.82495C13.314 8.08807 13.314 8.54415 13.5771 8.80727L14.2963 9.52647H13.7175C11.7528 9.52647 9.87586 8.68448 8.57779 7.211L6.89381 5.3516C5.31507 3.57991 3.06976 2.5625 0.70166 2.5625C0.315747 2.5625 0 2.87825 0 3.26416C0 3.65007 0.298205 3.96582 0.684118 3.96582C2.66631 3.96582 4.54325 4.80781 5.84132 6.2813L7.50776 8.15824C9.0865 9.92993 11.3318 10.9298 13.6999 10.9298H14.2963L13.5771 11.649C13.314 11.9121 13.314 12.3682 13.5771 12.6313C13.8402 12.8944 14.2963 12.8944 14.5594 12.6313L16.4715 10.7193C16.7346 10.4386 16.7346 10.0001 16.4539 9.73697Z"
              fill="#03002F"
            />
          </svg>
        ),
        role: "customer",
        sales: false,
        key: "switchFamily",
        employeeNavigation: {
          navigateTo: "/selectfamilies",
        },
        familyOfficeNavigation: {
          navigateTo: "/linkedclients",
        },
        stateObject: {
          from: "switchFamily",
          path: location.pathname,
        },
      },
      {
        heading: "Logout",
        image: (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.44052 4.37559L7.45652 0.879336C7.963 0.564174 8.62418 0.939668 8.62418 1.56889V2.61906H13.8431C14.2696 2.61906 14.615 2.97857 14.615 3.42184V6.7674C14.615 7.82335 13.0712 7.82335 13.0712 6.7674V4.22462H8.62418V16.355H13.0712V13.8122C13.0712 12.7566 14.615 12.7566 14.615 13.8122V17.1578C14.615 17.6013 14.2696 17.9606 13.8431 17.9606H8.62418L8.62126 19.011C8.62179 19.5915 8.03505 19.9882 7.52063 19.7323L0.504625 16.236C0.210062 16.1228 0 15.828 0 15.4828L0.00317871 5.0971C0.0034436 4.79874 0.164765 4.51278 0.44052 4.37559ZM10.9651 9.27271C9.68031 9.27271 9.68031 11.3044 10.9651 11.3044H16.6658L15.5594 12.4549C14.6513 13.3993 16.0322 14.8357 16.9405 13.8913L19.7084 11.0124C20.0814 10.6245 20.1127 9.98512 19.7084 9.56473L16.9405 6.68585C16.0322 5.74147 14.6513 7.17788 15.5594 8.12226L16.6658 9.27271H10.9651Z"
              fill="#03002F"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.9636 9.27158C9.67882 9.27158 9.67882 11.3033 10.9636 11.3033H16.6644L15.5579 12.4538C14.6498 13.3982 16.0307 14.8346 16.939 13.8902L19.7069 11.0113C20.0799 10.6234 20.1112 9.984 19.7069 9.5636L16.939 6.68472C16.0307 5.74034 14.6498 7.17675 15.5579 8.12113L16.6644 9.27158H10.9636Z"
              fill="#03002F"
            />
          </svg>
        ),
        role: "",
        sales: true,
        key: "logout",
        navigateTo: "/",
      },
    ];

    const handleActiveTab = (tab) => {
      if (tab === "portfolio") {
        AuthStore.updateLoadingFullScreen(true);
        setActiveTab(tab);
        // const tabName =
        //   domesticAndOffshoreValue !== OFFSHORE ? { DOMESTIC } : { OFFSHORE };

        // navigate(`/${tab}`, {
        //   state: {
        //     from: tabName,
        //   },
        // });
      } else if (tab === "performance/overall performance") {
        PerformanceStore.setAssetClass({ id: "all", name: "Overall" });
        if (!location.pathname?.includes("performance"))
          UserStore.setPathFrom("fromPerformance", false);
        else UserStore.setPathFrom("fromPerformance", true);

        if (UserStore.fromPerformance) {
          PerformanceStore.setCurrentLoader("fullScreen");
          AuthStore.updateLoadingFullScreen(true);
          PerformanceStore.onFirstLoad();
          UserStore.setPathFrom("fromPerformance", false);
        }
        setActiveTab(tab);
        //navigate(`/${tab}`);
      } else if (tab === homePageRoute) {
        AuthStore.updateLoadingFullScreen(true);
        setActiveTab(tab);
        // navigate(`/${tab}`);
      } else {
        setActiveTab(tab);
        //navigate(`/${tab}`);
      }
    };

    //   const SettingsMenuContent = () => {
    //     const handleClickOnSettingOption = (key) => {
    //       setSettingsMenuOpen(false);
    //       setActiveTab("settings");
    //       navigate("/settings", { state: { from: key } });
    //     };

    //     return (
    //       <ul className="settings_listitem_container">
    //         {SettingsStore?.settingsOptionsArr?.map((menuItem) => {
    //           return (
    //             <li
    //               className="listitem with_btn"
    //               onClick={() => handleClickOnSettingOption(menuItem?.key)}
    //             >
    //               <button className="list_btn">
    //                 {menuItem?.image && (
    //                   <div className="icon_wrapper">
    //                     <img
    //                       className={menuItem.customCls ? menuItem.customCls : ""}
    //                       src={menuItem?.image}
    //                       alt="family access"
    //                     />
    //                   </div>
    //                 )}
    //                 <p className="listitem_text">{menuItem?.heading}</p>
    //               </button>
    //             </li>
    //           );
    //         })}
    //       </ul>
    //     );
    //   };

    //   const getDefaultImage = (name) => {
    //     if (!name) return;
    //     return <div className="profileImageDefault2">{name[0]}</div>;
    //   };

    //   const ReportMenuContent = () => {
    //       const handleClickOnReportOption = (key) => {
    //         setReportsMenuOpen(false);
    //         setActiveTab("reports");
    //         navigate(`/reports/${key}`, { state: { from: key } });
    //       };
    //       return (
    //         <ul className="reports_listitem_container report_button_animation">
    //           {reportsMenuDetails?.map((menuItem) => (
    //             <li
    //               role="menuitem"
    //               className="listitem with_btn"
    //               key={menuItem?.key}
    //               onClick={() => handleClickOnReportOption(menuItem?.key)}
    //             >
    //               <button className="list_btn">
    //                 <p className="listitem_text">{menuItem?.heading}</p>
    //               </button>
    //             </li>
    //           ))}
    //         </ul>
    //       );
    //     };
    //   const getProfileImage = () => {
    //     if (decodedToken?.user_type === "manager") {
    //       if (UserStore.userData?.profile_pic && UserStore.singleUsersUrl) {
    //         return (
    //           <img
    //             className="profile"
    //             src={UserStore.singleUsersUrl}
    //             alt="profile"
    //           />
    //         );
    //       } else {
    //         return getDefaultImage(UserStore.userData?.full_name);
    //       }
    //     } else {
    //       if (
    //         UserStore.currentFamilyMembers?.find(
    //           (item) => item.user_id === UserStore.selectedUsersId
    //         )?.profile_pic &&
    //         UserStore.singleUsersUrl
    //       ) {
    //         return (
    //           <img className="profile" src={UserStore.singleUsersUrl} alt="" />
    //         );
    //       } else {
    //         return getDefaultImage(UserStore.userData?.full_name);
    //       }
    //     }
    //   };

    useLayoutEffect(() => {
      setUserDetails({
        name: decodedToken?.full_name,
        role:
          decodedToken?.user_type === "manager"
            ? familyOfficeTeamNameText
            : decodedToken?.user_type === "customer"
              ? ""
              : "Employee",
      });
      //PROFILE MENNU FILTER

      if (UserStore.isSalesForceLogin) {
        const newProfileArr = profileMenuDetails.filter((data) => data?.sales);
        setProfileArr(newProfileArr);
      } else {
        const newProfileArr = profileMenuDetails.filter(
          (data) => !data?.role?.includes(decodedToken?.user_type),
        );
        setProfileArr(newProfileArr);
      }
      // eslint-disable-next-line
    }, []);

    // const MenuContent = ({ menu, handleClick }) => {
    //   return (
    //     <>
    //       <ul className="reports_listitem_container report_button_animation">
    //         {menu?.map((menuItem) => (
    //           <li
    //             className="listitem with_btn"
    //             key={menuItem?.key}
    //             onClick={() => handleClick(menuItem?.key)}
    //           >
    //             <button className="list_btn">
    //               <p className="listitem_text">{menuItem?.heading}</p>
    //             </button>
    //           </li>
    //         ))}
    //       </ul>
    //     </>
    //   );
    // };

    // // const ReportMenuContent = () => {
    // //   const handleClickOnReportOption = (key) => {
    // //     setReportsMenuOpen(false);
    // //     setActiveTab("reports");
    // //     navigate(`/reports/${key}`, { state: { from: key } });
    // //   };
    // //   return (
    // //     <ul className="reports_listitem_container report_button_animation">
    // //       {reportsMenuDetails?.map((menuItem) => (
    // //         <li
    // //           role="menuitem"
    // //           className="listitem with_btn"
    // //           key={menuItem?.key}
    // //           onClick={() => handleClickOnReportOption(menuItem?.key)}
    // //         >
    // //           <button className="list_btn">
    // //             <p className="listitem_text">{menuItem?.heading}</p>
    // //           </button>
    // //         </li>
    // //       ))}
    // //     </ul>
    // //   );
    // // };

    //  const ProfileMenuContent = () => {
    //   const handleClickOnProfileOption = (heading) => {
    //     switch (heading) {
    //       case "View Profile":
    //         setProfileMenuOpen(false);
    //         navigate("/profile");
    //         break;
    //       case "Switch Family":
    //         setProfileMenuOpen(false);
    //         if (decodedToken?.user_type === "manager") {
    //           navigate("/linkedclients", {
    //             state: { from: "switchFamily", path: location.pathname },
    //           });
    //         } else if (decodedToken?.user_type === "employee") {
    //           navigate("/selectfamilies", {
    //             state: { from: "switchFamily", path: location.pathname },
    //           });
    //         }
    //         break;
    //       case "Unlock Accounts":
    //         setProfileMenuOpen(false);
    //         navigate("/unlockaccount");
    //         break;
    //       case "Logout":
    //         logout();
    //         navigate("/");

    //         break;
    //       default:
    //         break;
    //     }
    //   };
    //   return (
    //     <>
    //       <p className="profile_menu_heading">
    //         Member since {getDisplayDate(getMemberSinceDate())}
    //         <span>{UserStore.usersData}</span>
    //       </p>
    //       <ul className="profile_listitem_container">
    //         {profileArr?.map((menuItem) => {
    //           if (menuItem.heading === "View Profile") {
    //             return (
    //               <li
    //                 role="menuitem"
    //                 className="listitem with_btn"
    //                 onClick={() => handleClickOnProfileOption(menuItem.heading)}
    //               >
    //                 <button className="list_btn" role="menuitem">
    //                   {getProfileImage()}{" "}
    //                   <p className="listitem_text">{getCookie("name")}</p>
    //                 </button>
    //               </li>
    //             );
    //           } else {
    //             return (
    //               <li
    //                 role="menuitem"
    //                 className="listitem with_btn"
    //                 onClick={() => handleClickOnProfileOption(menuItem.heading)}
    //               >
    //                 <button className="list_btn" role="menuitem">
    //                   {menuItem?.image && (
    //                     <div className="icon_wrapper">{menuItem?.image}</div>
    //                   )}
    //                   <p className="listitem_text">{menuItem?.heading}</p>
    //                 </button>
    //               </li>
    //             );
    //           }
    //         })}
    //       </ul>
    //     </>
    //   );
    // };

    // function getMemberSinceDate() {
    //   const isPrimary = getCookie("isSelectedUserPrimary");
    //   const inceptionDates = getCookie("inceptionDates");

    //   // Primary users inception date and that families family inception date is same,
    //   // Then 1. Primary clients login , 2. Employee / Liaison login and Primary member selected from all available families , we display , families inception date , even if we change the client from global "All Member" button
    //   // Otherwise display Clients inception date if non primary is choosen from the families screen or the login is of non-primary member itself

    //   if (isPrimary && !JSON.parse(isPrimary))
    //     return inceptionDates?.client_inceptiondate;
    //   else return inceptionDates?.family_inceptiondate;
    // }

    useEffect(() => {
      if (UserStore.isHydrated) {
        setDomesticAndOffshoreValue(getUsersOffshoreValue({}));
      }
    }, [UserStore.isHydrated, UserStore.userData]);

    return (
      <>
        <SkipToMainContent />
        {/* <button
        onClick={() => dataRef.current.focus()}
        ></button> */}
        <header className="primary_bg_header" role="banner">
          <div
            className={
              type === homePageRoute
                ? "header_container home_header"
                : "header_container"
            }
            style={{
              backgroundColor: "#03002f",
            }}
          >
            <div className="logo_navigation_wrapper">
              <div className="logo_wrapper">
                {/* {
                isLogoNavigationEnabled === false ? (
                  <>
                    <span aria-label={`${logoAriaLabel} logo`}>
                      <NuvamaLogo className="header_logo" />
                    </span>
                  </>
                )
                 :
                  (
                  <Link
                    to={
                      domesticAndOffshoreValue !== OFFSHORE
                        ? `/${homePageRoute}`
                        : "/portfolio"
                    }
                    state={
                      domesticAndOffshoreValue !== OFFSHORE
                        ? {}
                        : { from: OFFSHORE }
                    }
                    aria-label={logoAriaLabel}
                  >
                    <NuvamaLogo className="header_logo" />
                  </Link>
                )} */}
                <Link
                  to={
                    domesticAndOffshoreValue !== OFFSHORE
                      ? `/${homePageRoute}`
                      : "/portfolio"
                  }
                  state={
                    domesticAndOffshoreValue !== OFFSHORE
                      ? {}
                      : { from: OFFSHORE }
                  }
                  aria-label={logoAriaLabel}
                >
                  <span aria-hidden={true} focusable="false">
                    <NuvamaLogo className="header_logo" />
                  </span>
                </Link>
              </div>
              {type && (
                <div className="navigation_container">
                  {domesticAndOffshoreValue !== OFFSHORE ? (
                    <Link
                      to={`/${homePageRoute}`}
                      className="homeBtn link-tag"
                      onClick={() => handleActiveTab(homePageRoute)}
                    >
                      {activeTab === homePageRoute ? (
                        <img
                          className="navigation clickable"
                          src={activatedHomeIcon}
                          alt={homePageRoute}
                        />
                      ) : (
                        <span className="navigation">
                          <svg
                            width="34"
                            height="34"
                            viewBox="0 0 34 34"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              x="0.5"
                              y="0.5"
                              width="33"
                              height="33"
                              rx="9.5"
                              stroke="#A8B1C1"
                              strokeOpacity="0.3"
                            />
                            <path
                              d="M14.5457 22.8509V20.7525C14.5457 20.2208 14.9781 19.7888 15.5137 19.7855H17.4802C18.0182 19.7855 18.4543 20.2184 18.4543 20.7525V22.8448C18.4543 23.306 18.8291 23.6808 19.2936 23.6842H20.6353C21.2619 23.6858 21.8634 23.4398 22.307 23.0005C22.7507 22.5612 23 21.9646 23 21.3425V15.3819C23 14.8794 22.7756 14.4027 22.3874 14.0803L17.8294 10.4613C17.0327 9.82835 15.8947 9.8488 15.1216 10.51L10.6616 14.0803C10.255 14.3932 10.012 14.8713 10 15.3819V21.3364C10 22.6331 11.0587 23.6842 12.3648 23.6842H13.6758C13.8994 23.6858 14.1145 23.5987 14.2732 23.4423C14.4319 23.2858 14.5212 23.073 14.5212 22.8509H14.5457Z"
                              fill="#A8B1C1"
                            />
                          </svg>
                        </span>
                      )}
                    </Link>
                  ) : (
                    ""
                  )}
                  {domesticAndOffshoreValue === COMBINED ? (
                    <div ref={portfolioRef} className="reports">
                      <ReportsMenuList
                        handleClick={() => {
                          //setReportsMenuOpen(false);
                          setActiveTab("portfolio");
                          //navigate(`/reports/${key}`, { state: { from: key } });
                        }}
                        buttonProps={{
                          buttonType: "reportsButton",
                          title: "Portfolio",
                          activeTab,
                          name: "portfolio",
                        }}
                        popupClassName={{
                          open: "clicked-hover",
                          close: "",
                          wrapperClass: "popup_menu_container",
                        }}
                        restrictHover={true}
                        itemRefs={portfolioItemRefs}
                        menuItems={portfolioMenuDetails}
                        accessibilityValues={{
                          buttonId: "portfolio-dropdown",
                          ariaHaspopup: "menu",
                          ariaControls: "portfolio-menu",
                          ariaLabel: "Portfolio",
                        }}
                        btnClass="reports-menu-button"
                      />
                      {/* <PopupMenu
                        MenuContent={() =>
                          MenuContent({
                            menu: portfolioMenuDetails,
                            handleClick: (tab) => {
                              setPortfolioMenuOpen(false);
                              setActiveTab("portfolio");
                              navigate(`/portfolio`, { state: { from: tab } });
                            },
                          })
                        }
                        open={portfolioMenuOpen}
                        setOpen={setPortfolioMenuOpen}
                      >
                        <button
                          className={`navigation arrow ${
                            activeTab === "portfolio" ? "is-active" : ""
                          }`}
                        >
                          Portfolio
                          <DownArrow />
                        </button>
                      </PopupMenu> */}
                    </div>
                  ) : (
                    <PageNavigationLink
                      title="Portfolio"
                      navigateTo={"/portfolio"}
                      stateObj={{
                        from:
                          domesticAndOffshoreValue !== OFFSHORE
                            ? { DOMESTIC }
                            : { OFFSHORE },
                      }}
                      className={`navigation ${
                        activeTab === "portfolio" ? "is-active" : ""
                      }`}
                      onClick={() => handleActiveTab("portfolio")}
                    />
                  )}
                  <Link
                    className={`navigation ${
                      activeTab === "performance/overall performance" ||
                      activeTab === "performance"
                        ? "is-active"
                        : ""
                    }`}
                    onClick={() => {
                      window.scrollTo(0, 0);
                      handleActiveTab("performance/overall performance");
                    }}
                    to={`/performance/overall performance`}
                  >
                    Performance
                  </Link>
                  <div ref={ref} className="reports">
                    <ReportsMenuList
                      handleClick={() => {
                        //setReportsMenuOpen(false);
                        setActiveTab("reports");
                        //navigate(`/reports/${key}`, { state: { from: key } });
                      }}
                      buttonProps={{
                        buttonType: "reportsButton",
                        title: "Reports",
                        activeTab,
                        name: "reports",
                      }}
                      popupClassName={{
                        open: "clicked-hover",
                        close: "",
                        wrapperClass: "popup_menu_container",
                      }}
                      restrictHover={true}
                      itemRefs={itemRefs}
                      menuItems={reportsMenuDetails}
                      accessibilityValues={{
                        buttonId: "reports-dropdown",
                        ariaHaspopup: "menu",
                        ariaControls: "reports-menu",
                        ariaLabel: "Reports",
                      }}
                      btnClass="reports-menu-button"
                    />
                  </div>
                  <Link
                    className={`navigation ${
                      activeTab === "analytics" ? "is-active" : ""
                    }`}
                    onClick={() => handleActiveTab("analytics")}
                    to={"/analytics"}
                  >
                    Analytics
                  </Link>
                </div>
              )}
            </div>
            {type && (
              <div className="settings_profile_wrapper" ref={settingRef}>
                {getDecodedToken()?.user_type !== "employee" && (
                  <SettingsMenuList
                    handleClick={() => {
                      setActiveTab("settings");
                    }}
                    buttonProps={{
                      buttonType: "settingsButton",
                      activeTab,
                    }}
                    popupClassName={{
                      open: "clicked-hover",
                      close: "",
                      wrapperClass:
                        "popup_menu_container settigs-menu-container",
                    }}
                    restrictHover={true}
                    itemRefs={settingsItemRefs}
                    menuItems={SettingsStore?.settingsOptionsArr}
                    accessibilityValues={{
                      buttonId: "settings-dropdown",
                      ariaHaspopup: "menu",
                      ariaControls: "settings-menu",
                      ariaLabel: "Settings",
                    }}
                    btnClass="reports-menu-button"
                  />
                )}

                <div className="icon_wrapper" style={{ height: 28 }}>
                  <Link
                    className="connect"
                    onClick={() => handleActiveTab("connect")}
                    to={"/connect"}
                    aria-label="Connect with our support team"
                  >
                    {activeTab === "connect" ? (
                      <img src={selectedSupportIcon} alt="support" />
                    ) : (
                      <span className="navigation">
                        <svg
                          width="28"
                          height="28"
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.57999 18.7926L5.26371 18.7684L5.31407 19.0815C5.48436 20.1407 5.98301 21.1274 6.74975 21.8958L6.92672 21.7192L6.74976 21.8958C7.71086 22.8589 9.01455 23.4001 10.374 23.4001H10.9207H11.2202L11.1667 23.1054C11.1456 22.9893 11.1345 22.8693 11.1345 22.7465C11.1345 22.6254 11.1455 22.5054 11.167 22.3878L11.2207 22.093H10.921H10.374C9.36111 22.093 8.3896 21.6898 7.67319 20.9719C7.13355 20.4311 6.77196 19.7451 6.6264 19.0054L6.58427 18.7913L6.36645 18.8041C6.09011 18.8203 5.81228 18.8104 5.57999 18.7926ZM6.98668 18.3884L7.00263 18.3828L7.01769 18.3752C7.324 18.2197 7.53449 17.901 7.53449 17.533V10.7127C7.53449 7.13286 10.4303 4.2317 14.0014 4.2317C17.5725 4.2317 20.4683 7.13286 20.4683 10.7127V17.533C20.4683 18.0536 20.8897 18.4766 21.4105 18.4766H22.3323C23.2272 18.4766 24.0854 18.1204 24.718 17.4864C25.3507 16.8524 25.706 15.9927 25.706 15.0964V13.1888C25.706 12.2925 25.3507 11.4328 24.718 10.7989C24.0901 10.1696 23.24 9.8139 22.3522 9.80865C21.9022 5.58629 18.3356 2.29688 14.0014 2.29688C9.66721 2.29688 6.10064 5.58629 5.65059 9.80865C4.76287 9.8139 3.91273 10.1696 3.2848 10.7989C2.65218 11.4328 2.29688 12.2925 2.29688 13.1888V15.0964C2.29688 15.9927 2.65217 16.8524 3.28479 17.4864C3.78364 17.9863 4.42273 18.3135 5.10957 18.4296C5.19879 18.4447 5.49341 18.4928 5.84763 18.5091C6.19547 18.5251 6.63018 18.5123 6.98668 18.3884ZM16.5629 22.7465C16.5629 21.8155 15.8096 21.0598 14.8792 21.0598H13.1236C12.6769 21.0598 12.2486 21.2377 11.9329 21.554C11.6172 21.8704 11.4399 22.2994 11.4399 22.7465C11.4399 23.6776 12.1933 24.4332 13.1236 24.4332H14.8792C15.8096 24.4332 16.5629 23.6776 16.5629 22.7465Z"
                            fill="#A8B1C1"
                            stroke="#A8B1C1"
                            stroke-width="0.5"
                          />
                        </svg>
                      </span>
                    )}
                  </Link>
                </div>
                <div ref={profileRef}>
                  <ProfileMenuList
                    handleClick={(heading) => {
                      if (heading === "Logout") {
                        logout();
                      }
                    }}
                    buttonProps={{
                      buttonType: "headerProfileButton",
                      userDetails,
                    }}
                    popupClassName={{
                      open: "clicked-hover",
                      close: "",
                      wrapperClass: "popup_menu_container",
                    }}
                    restrictHover={true}
                    itemRefs={profileItemRefs}
                    menuItems={profileArr}
                    accessibilityValues={{
                      buttonId: "profile-dropdown",
                      ariaHaspopup: "menu",
                      ariaControls: "profile-menu",
                      ariaLabel: "Profile",
                    }}
                    btnClass="dropDownBtn"
                  />
                </div>

                <img src={nuvamaexcel} id="nuvamaexcel" alt="" />
              </div>
            )}
          </div>
        </header>
      </>
    );
  }),
);

export default Header;
